import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import {connectForm} from '../../core/redux/form'
import {mediaQuery} from '../../core/browser'
import extract from '../../core/extract'
import {infoStatus} from '../../core/redux/status'
import SearchBar from '../../core/components/SearchBar'
import {DEFAULT_CONTACT_QUERY, CONTACT_CRITERIA_UPDATED, loadContactStream} from '../actions'
import {ContactCriteria} from '../models'
import i18n from '../i18n'

class ContactSearchBar extends Component {
    static propTypes = {
    }

    _search(event) {
        const {dispatch, location, criteria} = this.props

        if (event) {
            event.preventDefault()
        }
        
        return dispatch(loadContactStream({...DEFAULT_CONTACT_QUERY, ...criteria})).then(() => {
            if (location.pathname != '/providercontacts') {
                return dispatch(push('/providercontacts'))
            }
        })
    }

    _searchOnKeyPress(event) {
        if (event.key == 'Enter') {
            const {dispatch, location, criteria} = this.props

            return dispatch(loadContactStream({...DEFAULT_CONTACT_QUERY, ...criteria})).then(() => {
                if (location.pathname != '/providercontacts') {
                    return dispatch(push('/providercontacts'))
                }
            })
        }
    }

    render() {
        const {dispatch, location, criteria, form} = this.props

        return (
        	<SearchBar
                placeholder={extract(i18n.searchProviderContactStream, mediaQuery())}
                onClick={(e) => this._search(e)}
                onKeyPress={(e) => this._searchOnKeyPress(e)}
                {...form.fullText()}>
        	</SearchBar>
        )
    }
}

ContactSearchBar = connectForm({
    target: 'criteria',
    schema: ContactCriteria.schema,
    action: CONTACT_CRITERIA_UPDATED
})(ContactSearchBar)

ContactSearchBar = connect((state) => ({
    location: state.router.location,
    criteria: state.provider.contact.criteria
}))(ContactSearchBar)

export default ContactSearchBar


// WEBPACK FOOTER //
// ./lib/provider/components/ContactSearchBar.js